import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaCubes, FaChartBar, FaUsers, FaBell, FaBoxOpen, FaArrowLeft } from "react-icons/fa";

export function StoreLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const storeItems = [
    {
      title: "Sales",
      icon: <FaChartBar />,
      path: "/Sales",
      subItems: [
        { title: "Patient", path: "/Sales?type=patient" },
        { title: "Walkin", path: "/Sales?type=walkin" },
      ],
    },
    {
      title: "Inventory",
      icon: <FaCubes />,
      path: "/InventoryManage",
    },
    {
      title: "Patient Details",
      icon: <FaUsers />,
      path: "/PatientDetails",
    },
    {
      title: "Reminder",
      icon: <FaBell />,
      path: "/Reminder",
      subItems: [
        { title: "Patient Reminder", path: "/Reminder?tab=patient" },
        { title: "Balance Reminder", path: "/Reminder?tab=balance" },
      ],
    },
    {
      title: "Orders",
      icon: <FaBoxOpen />,
      path: "/OrderingStatus",
    },
  ];

  return (
    <div className="flex h-screen w-full bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <motion.div
        initial={{ x: -250 }}
        animate={{ x: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="w-64 flex-shrink-0 bg-black text-white h-full shadow-2xl flex flex-col z-20"
      >
        <div className="p-6 border-b border-white/10">
          <h2 className="text-2xl font-extrabold tracking-wider">STORE</h2>
          <p className="text-white/60 text-sm mt-1">Management Hub</p>
        </div>

        <div className="flex-1 overflow-y-auto py-6 px-4 space-y-2">
          {storeItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <div key={item.title} className="flex flex-col">
                <div
                  onClick={() => navigate(item.path)}
                  className={`flex items-center gap-4 px-4 py-3 rounded-lg cursor-pointer transition-all duration-300 ${
                    isActive
                      ? "bg-white text-black shadow-lg scale-105"
                      : "text-white/70 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  <div className={`text-xl ${isActive ? "text-black" : ""}`}>
                    {item.icon}
                  </div>
                  <span className="font-semibold">{item.title}</span>
                </div>
                
                {/* Render sub-items if active */}
                {item.subItems && isActive && (
                  <div className="ml-12 mt-2 flex flex-col gap-2">
                    {item.subItems.map((sub) => {
                      const isSubActive = 
                        location.pathname + location.search === sub.path || 
                        (location.search === "" && (sub.path.includes("tab=patient") || sub.path.includes("type=patient")));
                        
                      return (
                        <div
                          key={sub.title}
                          onClick={(e) => { e.stopPropagation(); navigate(sub.path); }}
                          className={`text-sm cursor-pointer transition-colors py-1 ${
                            isSubActive
                              ? "text-white font-bold"
                              : "text-white/60 hover:text-white"
                          }`}
                        >
                          • {sub.title}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={() => navigate("/Middle")}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors"
          >
            <FaArrowLeft />
            <span className="font-medium">Dashboard</span>
          </button>
        </div>
      </motion.div>

      {/* Main Content Area */}
      <div className="flex-1 h-full overflow-y-auto bg-gray-50 relative">
        <Outlet />
      </div>
    </div>
  );
}

export default StoreLayout;
